export const sortByFromBiggestJobs = (a: any, b: any) => {
  return b.jobs - a.jobs;
};

export const sortByFromBiggestKits = (a: any, b: any) => {
  return b.kits - a.kits;
};
